import React from 'react';
import { Dropdown, Form } from 'semantic-ui-react';
import { Label } from './label';
import { FieldError } from './field-error';
import { setupField } from '../utils/form-utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function DropdownField(props: any) {
  const { handleBlur, handleChange, field, error } = setupField(props);
  return (
    <Form.Field inline>
      <Label>{props.label}</Label>
      <Dropdown {...field} selection options={props.options} onChange={handleChange} onBlur={handleBlur} error={error}>
        {props.children}
      </Dropdown>
      <FieldError {...props}></FieldError>
    </Form.Field>
  );
}
